import { trim } from 'src/utils/string/trim';

export function nonBlanks(value?: string | null): boolean {
    return !!trim(value);
}
